var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quantity"},[_c('CustomTitle',{staticClass:"title",attrs:{"title":_vm.sumtitle}}),_vm._v(" "),_c('div',{staticClass:"chart"},[_c('Echart',{attrs:{"id":"quantity","options":_vm.options,"height":"100%","width":"100%"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bb133f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/workroomdp/components/Quantity.vue
// module id = null
// module chunks = 